import {IRouteStore} from '../../router/routing.infra';
import {getRootStore} from '../../app.bootstrap';
import {EmbeddedDashboardGeneralErrorController} from './embedded-dashboard-general-error.controller';
import {ILocalizationService} from '../../services/LocalizationService';

export interface IEmbeddedDashboardGeneralErrorStore extends IRouteStore {
    embeddedDashboardGeneralErrorController: EmbeddedDashboardGeneralErrorController;
    localizationService: ILocalizationService;
    dispose(): void;
}

export class EmbeddedDashboardGeneralErrorStore implements IEmbeddedDashboardGeneralErrorStore {
    public embeddedDashboardGeneralErrorController: EmbeddedDashboardGeneralErrorController;
    public localizationService: ILocalizationService;

    constructor() {
        const rootStore = getRootStore();
        this.localizationService = rootStore.localizationService;
        this.embeddedDashboardGeneralErrorController = new EmbeddedDashboardGeneralErrorController(
            rootStore.localizationService.translate,
            rootStore.jsApiService,
            rootStore.tsLocaleHelper
        );
    }

    dispose(): void {
        // Cleanup if needed
    }
}
